import { PriceControlSupplierAggregatedDTO } from '../dto';
import { PriceControlItem } from './PriceControlItem';

export class PriceControlSupplierAggregated {
  supplierName: string;
  supplierNumber: number;
  totalItemsFromSupplierInAssortment: number;
  suppliersItemsForPriceControlAmount: number;
  purchasePriceAverageDiffPercentage: number;
  purchasePriceAverageDiffAbsolute: number;
  salesPriceAverageDiffPercentage: number;
  salesPriceAverageDiffAbsolute: number;
  salesFactorAverageDiffPercentage: number;
  salesFactorMaxDiffPercentage: number;
  items: PriceControlItem[];

  constructor({
    supplierName,
    supplierNumber,
    totalItemsFromSupplierInAssortment,
    suppliersItemsForPriceControlAmount,
    purchasePriceAverageDiffPercentage,
    purchasePriceAverageDiffAbsolute,
    salesPriceAverageDiffPercentage,
    salesPriceAverageDiffAbsolute,
    salesFactorAverageDiffPercentage,
    salesFactorMaxDiffPercentage,
    items,
  }: PriceControlSupplierAggregated) {
    this.supplierName = supplierName;
    this.supplierNumber = supplierNumber;
    this.totalItemsFromSupplierInAssortment = totalItemsFromSupplierInAssortment;
    this.suppliersItemsForPriceControlAmount = suppliersItemsForPriceControlAmount;
    this.purchasePriceAverageDiffPercentage = purchasePriceAverageDiffPercentage;
    this.purchasePriceAverageDiffAbsolute = purchasePriceAverageDiffAbsolute;
    this.salesPriceAverageDiffPercentage = salesPriceAverageDiffPercentage;
    this.salesPriceAverageDiffAbsolute = salesPriceAverageDiffAbsolute;
    this.salesFactorAverageDiffPercentage = salesFactorAverageDiffPercentage;
    this.salesFactorMaxDiffPercentage = salesFactorMaxDiffPercentage;
    this.items = items;
  }

  static fromDto = (dto: PriceControlSupplierAggregatedDTO): PriceControlSupplierAggregated =>
    new PriceControlSupplierAggregated({
      supplierName: dto.supplierName,
      supplierNumber: dto.supplierNumber,
      totalItemsFromSupplierInAssortment: dto.totalItemsFromSupplierInAssortment,
      suppliersItemsForPriceControlAmount: dto.suppliersItemsForPriceControlAmount,
      purchasePriceAverageDiffPercentage: dto.purchasePriceAverageDiffPercentage,
      purchasePriceAverageDiffAbsolute: dto.purchasePriceAverageDiffAbsolute,
      salesPriceAverageDiffPercentage: dto.salesPriceAverageDiffPercentage,
      salesPriceAverageDiffAbsolute: dto.salesPriceAverageDiffAbsolute,
      salesFactorAverageDiffPercentage: dto.salesFactorAverageDiffPercentage,
      salesFactorMaxDiffPercentage: dto.salesFactorMaxDiffPercentage,
      items: dto.items ? dto.items.map(PriceControlItem.fromDto) : [],
    });
}
